// ── LA CHARTE DE L'ESPACE VOYAGEUR — couleurs et fontes ────────────────────
//
// DÉPLACÉ ICI DEPUIS `src/JourneyPage.jsx` (montage espace séjour v2), MOT POUR
// MOT : aucune valeur touchée, aucun commentaire réécrit. Le seul but est que
// les écrans v2 puissent lire la charte sans importer la page qui les rend
// (import circulaire). `JourneyPage` la ré-exporte : tout ce qui faisait
// `import { C, F } from './JourneyPage'` continue de fonctionner à l'identique.
//
// ⚠️ Les contrastes de ces valeurs ont été MESURÉS, et plusieurs couleurs de
// maquette ont été volontairement remplacées par des variantes plus lisibles.
// Ne pas revenir aux valeurs d'origine.

export const C = {
  // ── Charte 2026 « bleu-gris » (DA validée écran par écran par Dimitri,
  // 2026-07-31 — les maquettes revue-shots/decl-*.html + ref-fidel.html font
  // foi). Le marine historique est BANNI de ces écrans : la couleur vit sur
  // LA carte d'action (bleu), les boutons d'action sont TOUS ciel/encre —
  // zéro terracotta sur l'espace voyageur.
  bleu: "#3d5166", // carte d'action foncée · wordmark · titres tuiles services
  // ── ESPACE SÉJOUR — le navy du prototype de Dimitri, MESURÉ (2026-09-05) ──
  // Son bandeau et ses boutons pleins sont à #233240, pas à #3d5166. L'écart
  // se voit à l'œil : le montage était nettement plus clair que son dessin.
  // Token DÉDIÉ plutôt qu'un changement de `bleu` — celui-ci sert ailleurs
  // dans l'app, le déplacer emporterait des écrans qui n'ont rien demandé.
  sejourFond: "#233240",
  encre: "#2e3d4d", // texte posé sur ciel (boutons) · code promo
  muet: "#8a94a0", // eyebrow temporel · chevrons · libellés estompés
  ligne: "#e5e7eb", // filet topbar · bordure tuiles
  tuileFond: "#f4f7fa", // cases « fait » hors carte foncée · tuile témoin
  // Anciens tokens F.2 — encore référencés par le rendu legacy (drapeau
  // cartes OFF) : on ne réécrit pas ce chemin, on ne fait qu'en partager les
  // briques restylées (topbar, boutons, fonds).
  marine: "#215387",
  marineD: "#1b3a5c",
  marineDD: "#143350",
  ciel: "#87b8e6",
  cielBg: "#e4f0fb",
  corail: "#D85A30", // accents graphiques SANS texte (halo, bordure carte roi, ombres)
  corailCta: "#C74F28", // fonds portant du texte blanc (CTA, pastille active) — AA
  corailBg: "#FAECE7",
  corailTx: "#993C1D",
  // L'ambre du délai de 48 h (maquette : --or / --orBg / --orB / --orTx).
  or: "#d4a24c",
  orBg: "#fdf7ee",
  orB: "#ebd9b8",
  orTx: "#8a5f19",
  vert: "#1D9E75",
  vertBg: "#E1F5EE",
  vertTx: "#0F6E56",
  page: "#ffffff", // DA 2026 : fond de page BLANC (maquettes decl-*)
  card: "#ffffff",
  line: "#e5e8ec",
  lineSoft: "#eef1f4",
  ink: "#233240",
  inkSoft: "#5c6773",
  // (inkFaint #98a2ad maquette : abandonné partout au profit d'inkSoft —
  // arbitrage accessibilité Dimitri post-démo 2026-07-14.)
  red: "#dc2626", // bordures des blocs erreur (sign/checkout) — hors maquette
  redTx: "#b91c1c", // texte des blocs erreur (5,91:1 sur #fef2f2)
};

// DA 2026 : retour à la charte voyageur ADR-149 (Playfair Display + Raleway),
// celle des maquettes validées — la divergence temporaire F.2 (Fraunces/Libre
// Franklin, ADR-281) est refermée sur cet espace. Les deux familles sont déjà
// chargées globalement par public/index.html.
export const F = {
  serif: "'Playfair Display', Georgia, serif",
  sans: "'Raleway', system-ui, -apple-system, sans-serif",
};
